export default "/images/Opportunity1.png?7c90fa7313f3d55eb9e818b152f3dcbc";